(() => {
  const root = document.getElementById('practice-layout');
  const controls = root?.querySelector('.ycb-controls');
  if (!controls || root.dataset.optionsScroll) return;
  const selectors = ['.ycb-practice-type:not(.ycb-focus) select', '.ycb-focus select'];
  const selects = selectors.map(selector => controls.querySelector(selector));
  if (selects.some(select => !select || select.options.length < 3)) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let active = !reduced.matches, frame = 0, writing = false;
  const rows = selects.map((select, index) => {
    const options = [...select.options];
    const initial = Math.max(0, select.selectedIndex);
    const indices = [initial, ...options.map((_, i) => i).filter(i => i !== initial)].slice(0, 3);
    const shell = document.createElement('span');
    shell.className = 'ypo-select-shell';
    const display = document.createElement('span');
    display.className = 'ypo-value-window';
    display.setAttribute('aria-hidden', 'true');
    const measure = document.createElement('span');
    measure.className = 'ypo-value-measure';
    measure.textContent = options.reduce((a, option) => option.textContent.length > a.length ? option.textContent : a, '');
    const outgoing = document.createElement('span'), incoming = document.createElement('span');
    outgoing.className = incoming.className = 'ypo-value-line';
    display.append(measure, outgoing, incoming);
    select.before(shell); shell.append(display, select);
    return { select, options, indices, outgoing, incoming, thresholds: index ? [.36, .78] : [.18, .60] };
  });
  // Restore access only to these two native selects. Other prototype controls stay inert.
  const form = controls.closest('form');
  if (form?.hasAttribute('inert')) {
    [...form.children].forEach(child => { if (child !== controls) child.setAttribute('inert', ''); });
    [...controls.children].forEach(child => { if (!selects.some(select => child.contains(select))) child.setAttribute('inert', ''); });
    form.removeAttribute('inert');
  }
  controls.removeAttribute('inert');
  form?.querySelector('.ycb-practice')?.setAttribute('inert', '');
  root.dataset.optionsScroll = active ? 'active' : 'reduced';
  function draw(row, from, to = from, fraction = 0) {
    row.outgoing.textContent = row.options[from].textContent;
    row.incoming.textContent = from === to ? '' : row.options[to].textContent;
    row.outgoing.style.transform = `translateY(${-fraction * 100}%)`;
    row.incoming.style.transform = `translateY(${(1 - fraction) * 100}%)`;
    row.incoming.style.visibility = from === to ? 'hidden' : 'visible';
    const selected = fraction < .5 ? from : to;
    if (row.select.selectedIndex !== selected) {
      writing = true;
      row.select.selectedIndex = selected;
      row.select.dispatchEvent(new Event('input', { bubbles: true }));
      row.select.dispatchEvent(new Event('change', { bubbles: true }));
      writing = false;
    }
  }
  function still() { rows.forEach(row => draw(row, Math.max(0, row.select.selectedIndex))); }
  function render() {
    frame = 0;
    if (!active) return;
    const height = innerHeight;
    const range = Math.max(200, Math.min(height * .55, root.getBoundingClientRect().height * .85));
    const progress = Math.max(0, Math.min(1, (height * .86 - controls.getBoundingClientRect().top) / range));
    root.dataset.optionsScrollProgress = progress.toFixed(4);
    rows.forEach(row => {
      let state = 0;
      for (let i = 0; i < row.thresholds.length; i++) {
        const start = row.thresholds[i] - .045, end = row.thresholds[i] + .045;
        if (progress < start) break;
        if (progress >= end) { state = i + 1; continue; }
        const t = (progress - start) / (end - start);
        // The same scroll coordinate always yields the same two labels and position.
        draw(row, row.indices[i], row.indices[i + 1], t * t * (3 - 2 * t));
        return;
      }
      draw(row, row.indices[state]);
    });
  }
  function schedule() { if (active && !frame) frame = requestAnimationFrame(render); }
  function stop(mode = 'manual') {
    active = false; cancelAnimationFrame(frame); frame = 0;
    root.dataset.optionsScroll = mode;
    delete root.dataset.optionsScrollProgress;
    still();
    window.removeEventListener('scroll', schedule);
    window.removeEventListener('resize', schedule);
    window.visualViewport?.removeEventListener('resize', schedule);
    observer.disconnect();
  }
  rows.forEach(row => {
    const takeOver = () => { if (!writing) stop('manual'); };
    row.select.addEventListener('pointerdown', takeOver);
    row.select.addEventListener('focus', takeOver);
    row.select.addEventListener('keydown', takeOver);
    row.select.addEventListener('input', takeOver);
    row.select.addEventListener('change', takeOver);
  });
  const observer = new ResizeObserver(schedule);
  reduced.addEventListener('change', () => { if (reduced.matches) stop('reduced'); });
  if (active) {
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    observer.observe(root); observer.observe(controls); observer.observe(document.body);
    document.fonts?.ready.then(schedule);
    render();
  } else still();
})();
